import { useCallback, useMemo } from "react"
import { Userbot } from "../interfaces"
import { useClientsQuery } from "../store"

export interface ClientsLookupResult {
  getClient: (id: string | null | undefined) => Userbot.Client | undefined
  isLoading: boolean
}

export function useClientsLookup(): ClientsLookupResult {
  const { data, isLoading } = useClientsQuery({ limit: 500 })

  const map = useMemo(() => {
    const m = new Map<string, Userbot.Client>()
    data?.items?.forEach((c) => {
      if (c && c.id) {
        m.set(c.id, c)
      }
    })
    return m
  }, [data])

  const getClient = useCallback(
    (id: string | null | undefined) => {
      if (!id) return undefined
      return map.get(id)
    },
    [map],
  )

  return { getClient, isLoading }
}
